import createAxiosInstance from '../../../../api';
import { useDispatch } from 'react-redux';
import {
  setAllDealerListAction,
  setAllAssignDealerListAction,
} from '../../../../stores/actionTypes/dealerActions';
import { useAlert } from '../../../../components/Notification';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const dispatch = useDispatch();
  const showAlert = useAlert();

  const fetchGetAllDealerList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listDealer', payload)
      .then((response) => {
        dispatch(setAllDealerListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setAllDealerListAction([]));
      });
    return data;
  };

  const fetchGetAllAssignDealerList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listDealer', payload)
      .then((response) => {
        dispatch(setAllAssignDealerListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setAllAssignDealerListAction([]));
      });
    return data;
  };

  const fetchDealerDetails = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/getDealerDetails', payload)
      .then((response) => {
        data = response?.data?.data;
      })
      .catch(() => {
        showAlert('Failed get Dealer Details', 'warning');
      });
    return data;
  };

  const handleDeleteDealer = async (payload) => {
    await axiosInstance
      .post('/deleteDealer', payload)
      .then(() => {
        showAlert('Dealer deleted successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to delete  Dealer', 'warning');
      });
  };

  const updateDealerPassword = async (payload) => {
    await axiosInstance
      .post('/updateDealerPassword', payload)
      .then(() => {
        showAlert(`Update Password successfully`, 'success');
      })
      .catch(() => {
        showAlert(`Failed to Update Password`, 'error');
      });
  };

  return {
    fetchGetAllDealerList,
    fetchDealerDetails,
    handleDeleteDealer,
    fetchGetAllAssignDealerList,
    updateDealerPassword,
  };
}
